import React, { ReactElement, ReactNode } from 'react';
import Modal from 'rsuite/Modal';
import { ModalSize } from 'rsuite/esm/Modal/Modal';
import { t } from '@lingui/core/macro';
import cn from 'classnames';

import {CloseButton} from 'shared/ui/IconButton/iconButtons';
import Button from 'shared/ui/Button/Button/Button';
import { isTranslate } from 'shared/lib/lang';

import styles from './MainModal.module.scss';

import './MainModal.module.scss';


interface IMainModalProps {
    header: string|ReactElement,
    children: ReactNode,
    open: boolean,
    handleClose: () => void,
    size?: ModalSize
    isButtonResetFilters?: boolean;
    onResetFilters?: () => void;
    className?: string;
    dialogClassName?: string,
    headerClassName?: string,
}

const MainModal: React.FC<IMainModalProps> = ({
    header,
    children,
    open,
    handleClose,
    size= 'md',
    isButtonResetFilters = false,
    onResetFilters,
    dialogClassName,
    headerClassName,
    className,
}) => {

    return (
        <Modal
            backdrop="static"
            keyboard={false}
            open={open}
            onClose={handleClose}
            size={size}
            dialogClassName={dialogClassName}
            className={cn(
                styles[isTranslate() ? 'enBackground' : 'ruBackground'],
                className,
            )}
        >
            <Modal.Header
                className={cn(styles.header, headerClassName)}
                closeButton={false}
            >
                <Modal.Title>{header}</Modal.Title>
                <div className={styles.buttons}>
                    {
                        isButtonResetFilters &&
                        <Button variant="transparent" onClick={onResetFilters}>
                            {t`Сбросить фильтр`}
                        </Button>
                    }
                    <CloseButton
                        onClick={handleClose}
                        className={styles.closeButton}
                        title={t`Закрыть`}
                    />
                </div>
            </Modal.Header>

            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
};

export default MainModal;